export default __webpack_public_path__ + "static/media/140-1406395_childrens-health-logo.e4d6ce90.png";